/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPreferredCountryQueryVariables = Types.Exact<{
	[key: string]: never;
}>;

export type GetPreferredCountryQuery = {
	__typename?: 'Query';
	preferredCountryDcrs:
		| { __typename?: 'BadRequest' }
		| {
				__typename?: 'DCRResults';
				results: Array<{
					__typename?: 'DCR';
					id: any;
					country?: { __typename?: 'Country'; id: string } | null;
				}>;
		  }
		| { __typename?: 'Forbidden' };
};

export const GetPreferredCountryDocument = gql`
	query GetPreferredCountry {
		preferredCountryDcrs: getDcrs(
			paginationInput: { page: 1, pageSize: 1 }
			searchInput: { type: ADD }
		) {
			... on DCRResults {
				results {
					id
					country {
						id
					}
				}
			}
		}
	}
`;

/**
 * __useGetPreferredCountryQuery__
 *
 * To run a query within a React component, call `useGetPreferredCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferredCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferredCountryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreferredCountryQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetPreferredCountryQuery,
		GetPreferredCountryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetPreferredCountryQuery,
		GetPreferredCountryQueryVariables
	>(GetPreferredCountryDocument, options);
}
export function useGetPreferredCountryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetPreferredCountryQuery,
		GetPreferredCountryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetPreferredCountryQuery,
		GetPreferredCountryQueryVariables
	>(GetPreferredCountryDocument, options);
}
export function useGetPreferredCountrySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetPreferredCountryQuery,
				GetPreferredCountryQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetPreferredCountryQuery,
		GetPreferredCountryQueryVariables
	>(GetPreferredCountryDocument, options);
}
export type GetPreferredCountryQueryHookResult = ReturnType<
	typeof useGetPreferredCountryQuery
>;
export type GetPreferredCountryLazyQueryHookResult = ReturnType<
	typeof useGetPreferredCountryLazyQuery
>;
export type GetPreferredCountrySuspenseQueryHookResult = ReturnType<
	typeof useGetPreferredCountrySuspenseQuery
>;
export type GetPreferredCountryQueryResult = Apollo.QueryResult<
	GetPreferredCountryQuery,
	GetPreferredCountryQueryVariables
>;
